<script>
    import {location} from 'svelte-spa-router';
    import { t } from '../../i18n';

    export let menus = [
        {code: '/home',          title: 'nav.groups',           icon: 'bx bx-list-ul'},
        {code: '/chat',          title: 'nav.chat',             icon: 'bx bx-chat'},
        {code: '/invoices',      title: 'nav.documents',        icon: 'bx bx-file'},
    ];

    let isActive = function(code){
        let loc = $location;
        if(loc.match(/^\/quotation\/\d+$/)) loc = '/home';
        return loc===code;
    };
</script>

{#each menus as menu}
    <li class="nav-item" class:active={isActive(menu.code)}>
        <a href="#{menu.code}">
            <i class="{menu.icon}"></i>
            <span class="menu-title">{$t(menu.title)}</span>
        </a>
    </li>
{/each}
